export default __webpack_public_path__ + "static/media/10.3d8d8ac1.jpg";